// NOTICE: KAPTION-INTEGRATION
// usage-analytics.PRIVACY.3 — message-shape helpers. These derive BOUNDED enums
// from a message object (its type) without ever touching content/PII.

// Chatwoot message_type: 0 incoming, 1 outgoing, 2 activity, 3 template.
const MESSAGE_TYPE_LABELS = Object.freeze({
  0: 'incoming',
  1: 'outgoing',
  2: 'activity',
  3: 'template',
});

// Normalize a message's type to a short enum. Accepts a number or a message
// object (message_type / messageType). Unknown -> 'other'.
export function messageTypeLabel(messageOrType) {
  let type = messageOrType;
  if (messageOrType && typeof messageOrType === 'object') {
    type = messageOrType.message_type ?? messageOrType.messageType;
  }
  return MESSAGE_TYPE_LABELS[type] ?? 'other';
}

// True when the message is an outgoing (agent-authored) message. Used for
// reaction on_own_message without reading the author identity.
export function isOutgoingMessage(messageOrType) {
  return messageTypeLabel(messageOrType) === 'outgoing';
}
